import { Controller, useFormContext } from 'react-hook-form'
import { GroupBase } from 'react-select'
import clsx from 'clsx'

import { Select } from 'Components/Select/Select'
import { SelectOption } from 'Components/Select/Select.types'

import { FieldSelectProps } from './Field.types'

export const FieldSelect = <
  Option extends SelectOption,
  IsMulti extends boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: FieldSelectProps<Option, IsMulti, Group>,
) => {
  const { name, selectProps, hasError, e2eSelector } = props
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, onChange, ...field } }) => (
        <Select
          ref={ref}
          {...field}
          {...selectProps}
          className={clsx(
            hasError && 'ReactSelect--hasError is-invalid',
            selectProps?.className,
          )}
          inputId={name}
          instanceId={e2eSelector}
          onChange={(selected, actionMeta) =>
            typeof selectProps?.onChange === 'function'
              ? onChange(selectProps?.onChange(selected, actionMeta))
              : onChange(selected, actionMeta)
          }
        />
      )}
    />
  )
}
